export function mergeSchema(...schemas) {
  const [first, ...rest] = schemas;

  return rest.reduce(
    (mergedSchemas, schema) => (schema ? mergedSchemas.concat(schema) : mergedSchemas),
    first,
  );
}
